module.exports = __webpack_public_path__ + "img/黄慧雅.277be816.png";